import React, {memo, useMemo} from "react";
import {configuratorState} from "../../../state";
import {useSnapshot} from "valtio";
/*
  --------------------------------------------------
   model
*/

const ModuleModel = ({geom, material, att}) => {
  const {modelPartsSelectorStatus, selectedOrientation} = useSnapshot(configuratorState);
  
  const groupTagName = att ? att.group : 'static';
  const groupSetName = att ? att.set : 'static';
  
  let isNode;
  let name;
  let vis = true;
  
  if (att === false) {
    vis = false;
  }
  
  if (geom.name.includes('Node')) {
    name = geom.name.split('-')[0];
    isNode = true;
  } else {
    name = geom.name;
  }
  
  const getModelActive = () => {
    
    if (!modelPartsSelectorStatus) return true;
    
    if (isNode || material === null || vis === false) {
      return false;
    } else {
      if(groupSetName && groupSetName.includes("&&"))
      {
        let groupSets = groupSetName.split("&&");
        let returnValue = true;
        for(let set of groupSets)
        {
          returnValue = modelPartsSelectorStatus[set];
          if(!returnValue) break;
        }
        return returnValue;
      }
      else
      {
        return groupTagName === 'static' || modelPartsSelectorStatus[groupSetName];
      }
    }
    
  }
  
  const setOrientation = () => {
    
    if (!selectedOrientation) return;
    
    let flipX;
    
    if (selectedOrientation.title === groupSetName) {
      flipX = 1;
      if (selectedOrientation.orientationSelected === 0) {
        flipX = 1;
      } else {
        flipX *= -1;
      }
      return [flipX, 1, 1];
    }
  }
  
  return (
    <mesh
      visible={getModelActive()}
      scale={setOrientation()}
      name={name}
      material={material}
      geometry={geom.geometry}
      position={geom.position}
      rotation={geom.rotation}
      castShadow="" receiveShadow="">
    </mesh>
  )
  
};

export const MemModuleModel = memo(ModuleModel);
